import styled, { css } from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 5px;

  ${props =>
    props.isPortrait &&
    css`
      margin-top: 0;
      flex-direction: column;
      justify-content: start;
      height: 100%;
    `}
`

const CarouselArrows = styled.div`
  align-self: stretch;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 7px;
  cursor: pointer;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        display: none;
      }
    `}
  ${props =>
    props.setDarkArrows &&
    css`
      background-color: ${props.theme.color.monochrome.dark};
      margin: ${props.theme.size.space['1']} ${props.theme.size.space['2']};
      width: ${props.theme.size.space['10']};
      left: ${props.isBack ? 0 : 'auto'};
      right: ${!props.isBack ? 0 : 'auto'};
      svg {
        fill: ${props.theme.color.content.white};
      }
      &:hover,
      &:focus {
        background-color: ${props.theme.color.monochrome.base};
      }
    `}
`

const Thumbnails = styled.div`
  overflow: hidden;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;

        ${props.isPortrait &&
          css`
            overflow-y: scroll;
          `}
      }
    `}
`

const ThumbnailItem = styled.ul`
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 5px;

  ${props =>
    props.isPortrait &&
    css`
      flex-direction: column;
      width: auto;
      padding: 0;

      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        flex-direction: row;
      }
    `}
`

const ThumbnailIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

const ThumbnailAR3DIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const ImageContainer = styled.li`
  display: flex;
  cursor: pointer;
  border-radius: 3px;
  position: relative;
  flex: 0 0 auto;
  border: 1px solid ${props => props.theme.color.monochrome.light};
  &:first-child {
    margin-left: 0 !important;
  }
  &:last-child {
    margin-right: 0 !important;
  }
  ${props =>
    props.active &&
    css`
      border: 2px solid ${props.theme.color.palette['brand-1']};
    `}
  ${props =>
    props.isInModal &&
    css`
      background: ${props.theme.color.monochrome.white};
      border: 3px solid ${props.theme.color.monochrome.light};
    `}
  ${props =>
    props.active &&
    props.isInModal &&
    css`
      border: 3px solid ${props.theme.color.monochrome.white};
      box-shadow: 0 0 0 3px ${props.theme.color.palette['blue-70']};
    `}
`

const Image = styled.img`
  user-select: none;
  width: 100%;
  height: 100%;

  ${props =>
    props.svgOverlay &&
    css`
      opacity: 0.15;
    `}
`

export { Container, CarouselArrows, Thumbnails, ThumbnailItem, ThumbnailIcon, ThumbnailAR3DIcon, ImageContainer, Image }
